import { render, staticRenderFns } from "./FencingRequests.vue?vue&type=template&id=0f2096c3"
import script from "./FencingRequests.vue?vue&type=script&lang=js"
export * from "./FencingRequests.vue?vue&type=script&lang=js"
import style0 from "./FencingRequests.vue?vue&type=style&index=0&id=0f2096c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports